import React, { useState, useEffect } from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { useAuth } from '../config/AuthContext'; // Importe o useAuth
import config from '../config/config';

const HomeScreen = () => {
  //Variaveis para armazenar a lista de nomes dos dispositivos pelo id da maquina
  const [nomeList, setNomeList] = useState({});
  //Id inserido na LoginScreen pelo usuário
  const { maquinaId } = useAuth();
  //Constante para realizar a navegação entre as telas
  const navigation = useNavigation();
  const [alarmesPorNome, setAlarmesPorNome] = useState({});

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 5000);
    return () => clearInterval(interval);
  }, []);

  //Data em tempo real para simulação !!(TEMPORARIA)!!
  const getCurrentDateTime = () => {
    const currentDateTime = new Date();
    return currentDateTime.toLocaleString();
  };

  async function fetchData() {
    try {
      // const azureUrl = 'http://localhost:3001/api';
      const tableName = 'equipstates';
      const tabelaEndpoint = `${config.apiBaseUrl}/tables/${tableName}?$filter=maquinaId eq '${maquinaId}'`;
      const response = await fetch(tabelaEndpoint, {
        headers: {
          'ZUMO-API-VERSION': '2.0.0',
        },
      });
      const data = await response.json();

      const parsedData = JSON.parse(data[0].dados);

      const nomeList = parsedData.map((item) => item.Nome);

      const newAlarmesPorNome = {};

      parsedData.forEach((item) => {
        const nome = item.Nome;
        const alarme = item.Alarmes;

        if (!newAlarmesPorNome[nome]) {
          newAlarmesPorNome[nome] = [];
        }

        if (alarme && Array.isArray(alarme)) {
          alarme.forEach((alarmeItem) => {
            if (alarmeItem.Ativo) {
              newAlarmesPorNome[nome].push(alarmeItem.ativo);
            }
          });
        }
      });
      setAlarmesPorNome(newAlarmesPorNome);

      setNomeList(nomeList);
    } catch (error) {
      console.log(`Erro ao listar dados: ${error.message}`);
    }
  }

  return (
    <View style={styles.container}>
      {nomeList.length > 0 ? (
        nomeList.map((nome, index) => {
          const temAlarmeAtivo =
            alarmesPorNome[nome] && alarmesPorNome[nome].length > 0;

          return (
            <View
              style={[
                styles.list,
                { backgroundColor: temAlarmeAtivo ? '#FF0000' : '#969593' }, // Aplica cor de fundo vermelha se houver alarme ativo
              ]}
              key={nome}
            >
              <View>
                <Text style={styles.space}></Text>
              </View>
              <TouchableOpacity
                key={index}
                style={styles.buttonContainer}
                onPress={() =>
                  navigation.navigate('DeviceScreen', { deviceName: nome })
                }
              >
                <Text style={styles.buttonText}>{nome}</Text>
                <View style={styles.datetimeContainer}>
                  <Text style={styles.datetimeText}>
                    {getCurrentDateTime()}
                  </Text>
                </View>
              </TouchableOpacity>
            </View>
          );
        })
      ) : (
        <Text></Text>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#CCCCCA',
    flex: 1,
  },
  list: {
    flexDirection: 'column',
    backgroundColor: '#969593',
    borderRadius: 10,
    marginLeft: 10,
    marginRight: 10,
  },
  space: {
    padding: 2,
    backgroundColor: '#CCCCCA',
  },
  buttonContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 10,
    paddingBottom: 10,
  },
  buttonText: {
    color: '#F3F3F1',
    paddingLeft: 10,
    fontSize: 22,
    fontWeight: 'bold',
  },
  datetimeContainer: {
    flex: 1,
    alignItems: 'flex-end',
    paddingRight: 10,
  },
  datetimeText: {
    fontSize: 12,
    color: '#F3F3F1',
  },
});

export default HomeScreen;
